import { MantineTheme } from "@mantine/core";

export const componentStyles = {
  Text: (theme: MantineTheme) => ({
    
  })
};
